<template>
  <div class="flex items-center justify-between">
    <p>{{ deal.business.business_legal_name }}</p>
    <div class="flex items-center space-x-4">
      <lf-badge class="rounded-full">
        {{ getCurrentValue(deal) }}
      </lf-badge>
      <icon-chevron-up class="-rotate-90" :fill="`rgb(${COLORS[15]})`" />
      <lf-badge class="rounded-full">
        {{ selectedValue.item.value }}
      </lf-badge>
    </div>
  </div>
</template>
<script lang="ts">
import type {
  IApplication,
  MultiselectModalSelected,
} from "@/models/applications";
import type { PropType } from "vue";
</script>
<script setup lang="ts">
import { COLORS } from "@/helpers/constants";
import { DATA_OPTIONS } from "@/helpers/constants/deals";

import IconChevronUp from "@/components/icons/deals/IconChevronUp.vue";
import LfBadge from "@/components/ui/LfBadge.vue";

const props = defineProps({
  deal: {
    type: Object as PropType<IApplication>,
    required: true,
  },
  selectedValue: {
    type: Object as PropType<MultiselectModalSelected>,
    required: true,
  },
});

const getCurrentValue = (deal: IApplication) => {
  const key = props.selectedValue.key as (typeof DATA_OPTIONS)[number];

  const {
    underwriter_full_name,
    advisor_full_name,
    analyst_full_name,
    workflow_status,
  } = deal;

  if (key === DATA_OPTIONS.WORKFLOW_STATUS) {
    return workflow_status?.status || "-";
  }

  if (key === DATA_OPTIONS.WORKFLOW_SUB_STATUS) {
    return workflow_status?.sub_status || "-";
  }

  const userTypeToName = {
    [DATA_OPTIONS.UNDERWRITER]: underwriter_full_name,
    [DATA_OPTIONS.ADVISOR]: advisor_full_name,
    [DATA_OPTIONS.ANALYST]: analyst_full_name,
  };

  return userTypeToName[props.selectedValue.key] || "-";
};
</script>
